/**
 * The application's single API client.
 *
 * Built at module scope, not inside a component. The token store behind it
 * holds the in-memory access token, so rebuilding it on a re-render would drop
 * the session — and StrictMode's double-mount in development is exactly the
 * case that would expose that.
 *
 * A module rather than a field on `app.tsx` so that the route table, which is
 * also module-scoped, can reach it without importing the component that
 * renders it. That import would be a cycle.
 */

import { ApiClient, TokenStore } from "@hardauto/core-api";

import { config } from "./config";

export const tokens = new TokenStore();

export const client = new ApiClient({
  baseUrl: config.apiBaseUrl,
  tenantId: config.tenantId,
  tokens,
});
